module.exports = __webpack_public_path__ + "static/img/Hort Innovation logo_grey maroon transparent.e5d85ef5.webp";